import { TRootState } from 'redux/reducers/rootReducer';
import { setNavigation } from 'redux/reducers/app_action_reducers/navigationReducer';
import { RouteId } from 'types/frontend_models/navigation/RouteId';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { sidebarRoutes } from 'components/navigation/routes';
import { useEffect } from 'react';

interface IProps
{
    routeId: RouteId,
    topBarTitle?: string
}

function useNav(props: IProps)
{
    const dispatch = useDispatch();
    const location = useLocation();
    //??
    let route = sidebarRoutes.find(route => route.path === location.pathname);
    if (route === null) {
        route = sidebarRoutes.find(route => route.routeId === RouteId.home);
    }

    const currentNav = useSelector((state: TRootState) => state.app.navigation.navigation);

    let shouldChangeNav = false;
    if (props.routeId !== currentNav.activeRouteId) {
        shouldChangeNav = true;
    } else if (props.topBarTitle && props.topBarTitle !== currentNav.topbarTitle) {
        shouldChangeNav = true;
    }

    useEffect(() =>
    {
        if (shouldChangeNav) {
            dispatch(setNavigation({
                navigation: {
                    activeRouteId: props.routeId,
                    topbarTitle: props.topBarTitle ? props.topBarTitle : ''
                }
            }))
            // document.title = docTitle //  Maybe later?
        }
    }, [dispatch, props, shouldChangeNav]);
}


export default useNav